import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <>
      {/* BREADCRUMB AREA START */}
      <div
        className="ltn__breadcrumb-area text-left bg-overlay-white-30 bg-image "
        data-bs-bg="img/bg/surise-cover.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__breadcrumb-inner">
                <h1 className="page-title">About Us</h1>
                <div className="ltn__breadcrumb-list">
                  <ul>
                    <li>
                      <Link to="index.html">
                        <span className="ltn__secondary-color">
                          <i className="fas fa-home" />
                        </span>{" "}
                        Home
                      </Link>
                    </li>
                    <li>About Us</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* BREADCRUMB AREA END */}
      {/* ABOUT US AREA START */}
      <div className="ltn__about-us-area pt-25--- pb-120 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <div className="about-us-img-wrap about-img-left">
                <img src="img/others/9.png" alt="About Us Image1" />
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-30">
                  <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color d-none">
                    About Us
                  </h6>
                  <h1 className="section-title">
                    Your faithful partners Medical Goods
                  </h1>
                  <p>
                    Houzez allow you to design unlimited panels and real estate
                    custom forms to capture leads and keep record of all
                    information
                  </p>
                </div>
                <ul className="ltn__list-item-1 ltn__list-item-1-before--- clearfix">
                  <li>
                    <i className="fas fa-check-square" /> Better security for
                    patient privacy and information.
                  </li>
                  <li>
                    <i className="fas fa-check-square" /> More products at lower
                    prices.
                  </li>
                  <li>
                    <i className="fas fa-check-square" /> connect customers with
                    the power of eCommerce at all.
                  </li>
                </ul>
                <div className="about-author-info-2 border-top mt-30 pt-20">
                  <ul>
                    <li>
                      <div className="about-author-info-2-brief  d-flex">
                        <div className="author-img">
                          <img src="img/blog/author.jpg" alt="#" />
                        </div>
                        <div className="author-name-designation">
                          <h4 className="mb-0">Jerry Henson</h4>
                          <small>Medical Specialist</small>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="about-author-info-2-contact  d-flex">
                        <div className="about-contact-icon d-flex align-self-center mr-10">
                          <i className="icon-call" />
                        </div>
                        <div className="about-author-info-2-contact-info">
                          <small>Get Support</small>
                          <h6 className="mb-0">123-456-789-10</h6>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ABOUT US AREA END */}
      {/* COUNTDOWN AREA START */}
      <div
        className="ltn__call-to-action-area section-bg-1 bg-image pt-120 pb-120"
        data-bs-bg="img/bg/25.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="call-to-action-inner text-color-white--- text-center---">
                <div className="section-title-area ltn__section-title-2--- text-center---">
                  <h6 className="ltn__secondary-color">Todays Hot Offer</h6>
                  <h1 className="section-title">
                    Free Covid-19 Vaccine
                    <br />
                    Campaign Ticket
                  </h1>
                  <p>
                    Cur tantas regiones barbarorum obiit, tot maria transmist{" "}
                    <br />
                    summo bono fruitur id est voluptate barbarorum{" "}
                  </p>
                </div>
                <div
                  className="ltn__countdown ltn__countdown-3 bg-white--"
                  data-countdown="2021/12/28"
                />
                <div className="btn-wrapper animated">
                  <Link
                    to="contact.html"
                    className="theme-btn-1 btn btn-effect-1 text-uppercase"
                  >
                    Book Now
                  </Link>
                  <Link
                    to="shop.html"
                    className="ltn__secondary-color text-decoration-underline"
                  >
                    Deal of The Day
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              {/* <img src="img/banner/15.png" alt="#"> */}
            </div>
          </div>
        </div>
      </div>
      {/* COUNTDOWN AREA END */}
      {/* FEATURE AREA START ( Feature - 6) */}
      <div className="ltn__feature-area pt-90 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h1 className="section-title">Core Features</h1>
              </div>
            </div>
          </div>
          <div className="row ltn__custom-gutter">
            <div className="col-lg-3 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center">
                <div className="ltn__feature-icon">
                  {/* <span><i class="flaticon-apartment"></i></span> */}
                  <img src="img/icons/icon-img/24.png" alt="#" />
                </div>
                <div className="ltn__feature-info">
                  <h4>
                    <Link to="service-details.html">Free Delivery</Link>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit ame it, consectetur adipisicing elit,
                    sed do eiusmod te mp or incididunt ut labore.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center active">
                <div className="ltn__feature-icon">
                  {/* <span><i class="flaticon-park"></i></span> */}
                  <img src="img/icons/icon-img/25.png" alt="#" />
                </div>
                <div className="ltn__feature-info">
                  <h4>
                    <Link to="service-details.html">100% Cash Back</Link>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit ame it, consectetur adipisicing elit,
                    sed do eiusmod te mp or incididunt ut labore.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center">
                <div className="ltn__feature-icon">
                  {/* <span><i class="flaticon-maps-and-location"></i></span> */}
                  <img src="img/icons/icon-img/26.png" alt="#" />
                </div>
                <div className="ltn__feature-info">
                  <h4>
                    <Link to="service-details.html">Quality Product</Link>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit ame it, consectetur adipisicing elit,
                    sed do eiusmod te mp or incididunt ut labore.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center">
                <div className="ltn__feature-icon">
                  {/* <span><i class="flaticon-excavator"></i></span> */}
                  <img src="img/icons/icon-img/27.png" alt="#" />
                </div>
                <div className="ltn__feature-info">
                  <h4>
                    <Link to="service-details.html">24/7 Support</Link>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit ame it, consectetur adipisicing elit,
                    sed do eiusmod te mp or incididunt ut labore.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* FEATURE AREA END */}
      {/* PROGRESS BAR AREA START */}
      <div className="ltn__progress-bar-area section-bg-1 pt-120 pb-10 mb-120 d-none">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__progress-bar-wrap">
                <div className="ltn__progress-bar-inner">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6">
                      <div className="ltn__progress-bar-item-2 text-center">
                        <div className="progress" data-value={78}>
                          <span className="progress-left">
                            <span className="progress-bar border-primary" />
                          </span>
                          <span className="progress-right">
                            <span className="progress-bar border-primary" />
                          </span>
                          <div className="progress-value">
                            <div className="progress-count">
                              78<sup className="small">%</sup>
                            </div>
                          </div>
                        </div>
                        <div className="ltn__progress-info">
                          <h3>Project Done</h3>
                          <p>Construction Simulator</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                      <div className="ltn__progress-bar-item-2 text-center">
                        <div className="progress" data-value={62}>
                          <span className="progress-left">
                            <span className="progress-bar border-danger" />
                          </span>
                          <span className="progress-right">
                            <span className="progress-bar border-danger" />
                          </span>
                          <div className="progress-value">
                            <div className="progress-count">
                              62<sup className="small">%</sup>
                            </div>
                          </div>
                        </div>
                        <div className="ltn__progress-info">
                          <h3>Country Cover</h3>
                          <p>Construction Simulator</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                      <div className="ltn__progress-bar-item-2 text-center">
                        <div className="progress" data-value={50}>
                          <span className="progress-left">
                            <span className="progress-bar border-success" />
                          </span>
                          <span className="progress-right">
                            <span className="progress-bar border-success" />
                          </span>
                          <div className="progress-value">
                            <div className="progress-count">
                              50<sup className="small">%</sup>
                            </div>
                          </div>
                        </div>
                        <div className="ltn__progress-info">
                          <h3>Completed Co.</h3>
                          <p>Construction Simulator</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                      <div className="ltn__progress-bar-item-2 text-center">
                        <div className="progress" data-value={90}>
                          <span className="progress-left">
                            <span className="progress-bar border-warning" />
                          </span>
                          <span className="progress-right">
                            <span className="progress-bar border-warning" />
                          </span>
                          <div className="progress-value">
                            <div className="progress-count">
                              90<sup className="small">%</sup>
                            </div>
                          </div>
                        </div>
                        <div className="ltn__progress-info">
                          <h3>Happy Clients</h3>
                          <p>Construction Simulator</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* PROGRESS BAR AREA END */}
      {/* COUNTER UP AREA START */}
      <div
        className="ltn__counterup-area section-bg-1 bg-image bg-overlay-theme-black-80--- pt-115 pb-70"
        data-bs-bg="img/bg/30.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-sm-6 align-self-center">
              <div className="ltn__counterup-item text-center">
                <div className="counter-icon">
                  {/* <img src="img/icons/icon-img/2.png" alt="#">  */}
                  <i className="flaticon-add-user-1" />
                </div>
                <h1>
                  <span className="counter">733</span>
                  <span className="counterUp-icon">+</span>{" "}
                </h1>
                <h6>Active Clients</h6>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 align-self-center">
              <div className="ltn__counterup-item text-center">
                <div className="counter-icon">
                  {/* <img src="img/icons/icon-img/3.png" alt="#">  */}
                  <i className="flaticon-dining-table-with-chairs" />
                </div>
                <h1>
                  <span className="counter">33</span>
                  <span className="counterUp-letter">K</span>
                  <span className="counterUp-icon">+</span>{" "}
                </h1>
                <h6>Cup Of Coffee</h6>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 align-self-center">
              <div className="ltn__counterup-item text-center">
                <div className="counter-icon">
                  {/* <img src="img/icons/icon-img/3.png" alt="#">  */}
                  <i className="flaticon-package" />
                </div>
                <h1>
                  <span className="counter">100</span>
                  <span className="counterUp-icon">+</span>{" "}
                </h1>
                <h6>Get Rewards</h6>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 align-self-center">
              <div className="ltn__counterup-item text-center">
                <div className="counter-icon">
                  {/* <img src="img/icons/icon-img/3.png" alt="#">  */}
                  <i className="flaticon-maps-and-location" />
                </div>
                <h1>
                  <span className="counter">21</span>
                  <span className="counterUp-icon">+</span>{" "}
                </h1>
                <h6>Country Cover</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* COUNTER UP AREA END */}
      {/* TEAM AREA START (Team - 3) */}
      <div className="ltn__team-area pt-115 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h1 className="section-title">Our Expert Doctor</h1>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-4 col-sm-6">
              <div className="ltn__team-item ltn__team-item-3---">
                <div className="team-img">
                  <img src="img/team/4.jpg" alt="Image1" />
                </div>
                <div className="team-info">
                  <h4>
                    <Link to="team-details.html">Rosalina D. William</Link>
                  </h4>
                  <h6 className="ltn__secondary-color">Scientist</h6>
                  <div className="ltn__social-media">
                    <ul>
                      <li>
                        <Link to="#">
                          <i className="fab fa-facebook-f" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fab fa-twitter" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fab fa-linkedin" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="ltn__team-item ltn__team-item-3---">
                <div className="team-img">
                  <img src="img/team/2.jpg" alt="Image1" />
                </div>
                <div className="team-info">
                  <h4>
                    <Link to="team-details.html">Kelian Anderson</Link>
                  </h4>
                  <h6 className="ltn__secondary-color">Dentist</h6>
                  <div className="ltn__social-media">
                    <ul>
                      <li>
                        <Link to="#">
                          <i className="fab fa-facebook-f" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fab fa-twitter" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fab fa-linkedin" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="ltn__team-item ltn__team-item-3---">
                <div className="team-img">
                  <img src="img/team/5.jpg" alt="Image2" />
                </div>
                <div className="team-info">
                  <h4>
                    <Link to="team-details.html">Miranda H. Halim</Link>
                  </h4>
                  <h6 className="ltn__secondary-color">Caardiologist</h6>
                  <div className="ltn__social-media">
                    <ul>
                      <li>
                        <Link to="#">
                          <i className="fab fa-facebook-f" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fab fa-twitter" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fab fa-linkedin" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* TEAM AREA END */}
      {/* VIDEO AREA START */}
      <div className="ltn__video-popup-area ltn__video-popup-margin">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="ltn__video-bg-img ltn__video-popup-height-600 bg-overlay-black-10-- bg-image"
                data-bs-bg="img/bg/15.jpg"
              >
                <Link
                  className="ltn__video-icon-2 ltn__video-icon-2-border border-radius-no"
                  to="https://www.youtube.com/embed/Cr4LFOgRGeo?autoplay=1&showinfo=0"
                  data-rel="lightcase:myCollection"
                >
                  <i className="fa fa-play" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* VIDEO AREA END */}
      {/* TESTIMONIAL AREA START (testimonial-4) */}
      <div className="ltn__testimonial-area section-bg-1 pt-290 pb-70">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2 text-center">
                <h1 className="section-title">
                  Clients Feedbacks<span>.</span>
                </h1>
              </div>
            </div>
          </div>
          <div className="row ltn__testimonial-slider-3-active slick-arrow-1 slick-arrow-1-inner">
            <div className="col-lg-12">
              <div className="ltn__testimonial-item ltn__testimonial-item-4">
                <div className="ltn__testimoni-img">
                  <img src="img/testimonial/6.jpg" alt="#" />
                </div>
                <div className="ltn__testimoni-info">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipi sicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.{" "}
                  </p>
                  <h4>Rosalina D. William</h4>
                  <h6>Founder</h6>
                </div>
                <div className="ltn__testimoni-bg-icon">
                  <i className="far fa-comments" />
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="ltn__testimonial-item ltn__testimonial-item-4">
                <div className="ltn__testimoni-img">
                  <img src="img/testimonial/7.jpg" alt="#" />
                </div>
                <div className="ltn__testimoni-info">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipi sicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.{" "}
                  </p>
                  <h4>Rosalina D. William</h4>
                  <h6>Founder</h6>
                </div>
                <div className="ltn__testimoni-bg-icon">
                  <i className="far fa-comments" />
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="ltn__testimonial-item ltn__testimonial-item-4">
                <div className="ltn__testimoni-img">
                  <img src="img/testimonial/1.jpg" alt="#" />
                </div>
                <div className="ltn__testimoni-info">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipi sicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.{" "}
                  </p>
                  <h4>Rosalina D. William</h4>
                  <h6>Founder</h6>
                </div>
                <div className="ltn__testimoni-bg-icon">
                  <i className="far fa-comments" />
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="ltn__testimonial-item ltn__testimonial-item-4">
                <div className="ltn__testimoni-img">
                  <img src="img/testimonial/2.jpg" alt="#" />
                </div>
                <div className="ltn__testimoni-info">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipi sicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.{" "}
                  </p>
                  <h4>Rosalina D. William</h4>
                  <h6>Founder</h6>
                </div>
                <div className="ltn__testimoni-bg-icon">
                  <i className="far fa-comments" />
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="ltn__testimonial-item ltn__testimonial-item-4">
                <div className="ltn__testimoni-img">
                  <img src="img/testimonial/5.jpg" alt="#" />
                </div>
                <div className="ltn__testimoni-info">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipi sicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.{" "}
                  </p>
                  <h4>Rosalina D. William</h4>
                  <h6>Founder</h6>
                </div>
                <div className="ltn__testimoni-bg-icon">
                  <i className="far fa-comments" />
                </div>
              </div>
            </div>
            {/*  */}
          </div>
        </div>
      </div>
      {/* TESTIMONIAL AREA END */}
      {/* FAQ AREA START (faq-2) (ID > accordion_2) */}
      <div className="ltn__faq-area pt-115 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2 text-center">
                <h1 className="section-title white-color---">Some Questions</h1>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="ltn__faq-inner ltn__faq-inner-2">
                <div id="accordion_2">
                  {/* card */}
                  <div className="card">
                    <h6 className="ltn__card-title">
                      <button
                        className="collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-item-2-1"
                        aria-expanded="false"
                        aria-controls="faq-item-2-1"
                        type="button"
                      >
                        How to buy a product?
                      </button>
                    </h6>

                    <div
                      id="faq-item-2-1"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Scelerisque eleifend donec
                          pretium vulputate sapien nec sagittis. Proin libero
                          nunc consequat interdum. Condimentum lacinia quis vel
                          eros donec ac.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* card */}
                  <div className="card">
                    <h6 className="ltn__card-title">
                      <button
                        className="collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-item-2-2"
                        aria-expanded="true"
                        aria-controls="faq-item-2-2"
                        type="button"
                      >
                        How can I make a refund from your website?
                      </button>
                    </h6>
                    <div
                      id="faq-item-2-2"
                      className="collapse show"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <div className="ltn__video-img alignleft">
                          <img
                            src="img/bg/17.jpg"
                            alt="video popup bg image1"
                          />
                          <Link
                            className="ltn__video-icon-2 ltn__video-icon-2-small ltn__video-icon-2-border----"
                            to="https://www.youtube.com/embed/Cr4LFOgRGeo?autoplay=1&showinfo=0"
                            data-rel="lightcase:myCollection"
                          >
                            <i className="fa fa-play" />
                          </Link>
                        </div>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Scelerisque{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* card */}
                  <div className="card">
                    <h6 className="ltn__card-title">
                      <button
                        className="collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-item-2-3"
                        aria-expanded="false"
                        aria-controls="faq-item-2-3"
                      >
                        I am a new user. How should I start?
                      </button>
                    </h6>

                    <div
                      id="faq-item-2-3"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Scelerisque eleifend donec
                          pretium vulputate sapien nec sagittis. Proin libero
                          nunc consequat interdum. Condimentum lacinia quis vel
                          eros donec ac.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* card */}
                  <div className="card">
                    <h6 className="ltn__card-title">
                      <button
                        className="collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-item-2-4"
                        aria-expanded="false"
                        aria-controls="faq-item-2-4"
                      >
                        Returns and refunds
                      </button>
                    </h6>

                    <div
                      id="faq-item-2-4"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Scelerisque eleifend donec
                          pretium vulputate sapien nec sagittis. Proin libero
                          nunc consequat interdum. Condimentum lacinia quis vel
                          eros donec ac.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* card */}
                  <div className="card">
                    <h6 className="ltn__card-title">
                      <button
                        className="collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-item-2-5"
                        aria-expanded="false"
                        aria-controls="faq-item-2-5"
                      >
                        Are my details secured?
                      </button>
                    </h6>

                    <div
                      id="faq-item-2-5"
                      className="collapse"
                      data-bs-parent="#accordion_2"
                    >
                      <div className="card-body">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Scelerisque eleifend donec
                          pretium vulputate sapien nec sagittis. Proin libero
                          nunc consequat interdum. Condimentum lacinia quis vel
                          eros donec ac.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <aside className="about-us-img-wrap about-img-right">
                <img src="img/others/100.jpg" alt="Banner Image34" />
              </aside>
            </div>
          </div>
        </div>
      </div>
      {/* FAQ AREA START */}
      {/* FEATURE AREA START ( Feature - 6) */}
      <div className="ltn__feature-area section-bg-1 pt-115 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2 text-center">
                <h6 className="section-subtitle ltn__secondary-color">
                  features
                </h6>
                <h1 className="section-title">
                  Why Choose Us<span>.</span>
                </h1>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-7">
                <div className="ltn__feature-icon-title">
                  <div className="ltn__feature-icon">
                    {/* <span><img src="img/icons/icon-img/21.png" alt="#"></span> */}
                    <span>
                      <i className="fas fa-hand-holding-medical" />{" "}
                    </span>
                  </div>
                  <h3>
                    <Link to="service-details.html">All Kind Brand</Link>
                  </h3>
                </div>
                <div className="ltn__feature-info">
                  <p>
                    Lorem ipsum dolor sit ame it, consectetur adipisicing elit,
                    sed do eiusmod te mp or incididunt ut labore.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-7">
                <div className="ltn__feature-icon-title">
                  <div className="ltn__feature-icon">
                    {/* <span><img src="img/icons/icon-img/22.png" alt="#"></span> */}
                    <span>
                      <i className="fas fa-microscope" />{" "}
                    </span>
                  </div>
                  <h3>
                    <Link to="service-details.html">Curated Products</Link>
                  </h3>
                </div>
                <div className="ltn__feature-info">
                  <p>
                    Lorem ipsum dolor sit ame it, consectetur adipisicing elit,
                    sed do eiusmod te mp or incididunt ut labore.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-7">
                <div className="ltn__feature-icon-title">
                  <div className="ltn__feature-icon">
                    {/* <span><img src="img/icons/icon-img/23.png" alt="#"></span> */}
                    <span>
                      <i className="fas fa-stethoscope" />{" "}
                    </span>
                  </div>
                  <h3>
                    <Link to="service-details.html">Pesticide Free Goods</Link>
                  </h3>
                </div>
                <div className="ltn__feature-info">
                  <p>
                    Lorem ipsum dolor sit ame it, consectetur adipisicing elit,
                    sed do eiusmod te mp or incididunt ut labore.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* FEATURE AREA END */}
      {/* BLOG AREA START (blog-3) */}
      <div className="ltn__blog-area pt-115 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h1 className="section-title">Leatest News Feeds</h1>
              </div>
            </div>
          </div>
          <div className="row  ltn__blog-slider-one-active slick-arrow-1 ltn__blog-item-3-normal">
            {/* Blog Item */}
            <div className="col-lg-12">
              <div className="ltn__blog-item ltn__blog-item-3">
                <div className="ltn__blog-img">
                  <Link to="blog-details.html">
                    <img src="img/blog/1.jpg" alt="#" />
                  </Link>
                </div>
                <div className="ltn__blog-brief">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author">
                        <Link to="#">
                          <i className="far fa-user" />
                          by: Admin
                        </Link>
                      </li>
                      <li className="ltn__blog-tags">
                        <Link to="#">
                          <i className="fas fa-tags" />
                          Decorate
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <h3 className="ltn__blog-title">
                    <Link to="blog-details.html">
                      10 Brilliant Ways To Decorate Your Home
                    </Link>
                  </h3>
                  <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-date">
                          <i className="far fa-calendar-alt" />
                          June 24, 2021
                        </li>
                      </ul>
                    </div>
                    <div className="ltn__blog-btn">
                      <Link to="blog-details.html">Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Blog Item */}
            <div className="col-lg-12">
              <div className="ltn__blog-item ltn__blog-item-3">
                <div className="ltn__blog-img">
                  <Link to="blog-details.html">
                    <img src="img/blog/2.jpg" alt="#" />
                  </Link>
                </div>
                <div className="ltn__blog-brief">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author">
                        <Link to="#">
                          <i className="far fa-user" />
                          by: Admin
                        </Link>
                      </li>
                      <li className="ltn__blog-tags">
                        <Link to="#">
                          <i className="fas fa-tags" />
                          Interior
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <h3 className="ltn__blog-title">
                    <Link to="blog-details.html">
                      The Most Inspiring Interior Design Of 2021
                    </Link>
                  </h3>
                  <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-date">
                          <i className="far fa-calendar-alt" />
                          July 23, 2021
                        </li>
                      </ul>
                    </div>
                    <div className="ltn__blog-btn">
                      <Link to="blog-details.html">Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Blog Item */}
            <div className="col-lg-12">
              <div className="ltn__blog-item ltn__blog-item-3">
                <div className="ltn__blog-img">
                  <Link to="blog-details.html">
                    <img src="img/blog/3.jpg" alt="#" />
                  </Link>
                </div>
                <div className="ltn__blog-brief">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author">
                        <Link to="#">
                          <i className="far fa-user" />
                          by: Admin
                        </Link>
                      </li>
                      <li className="ltn__blog-tags">
                        <Link to="#">
                          <i className="fas fa-tags" />
                          Estate
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <h3 className="ltn__blog-title">
                    <Link to="blog-details.html">
                      Recent Commercial Real Estate Transactions
                    </Link>
                  </h3>
                  <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-date">
                          <i className="far fa-calendar-alt" />
                          May 22, 2021
                        </li>
                      </ul>
                    </div>
                    <div className="ltn__blog-btn">
                      <Link to="blog-details.html">Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Blog Item */}
            <div className="col-lg-12">
              <div className="ltn__blog-item ltn__blog-item-3">
                <div className="ltn__blog-img">
                  <Link to="blog-details.html">
                    <img src="img/blog/4.jpg" alt="#" />
                  </Link>
                </div>
                <div className="ltn__blog-brief">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author">
                        <Link to="#">
                          <i className="far fa-user" />
                          by: Admin
                        </Link>
                      </li>
                      <li className="ltn__blog-tags">
                        <Link to="#">
                          <i className="fas fa-tags" />
                          Room
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <h3 className="ltn__blog-title">
                    <Link to="blog-details.html">
                      Renovating a Living Room? Experts Share Their Secrets
                    </Link>
                  </h3>
                  <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-date">
                          <i className="far fa-calendar-alt" />
                          June 24, 2021
                        </li>
                      </ul>
                    </div>
                    <div className="ltn__blog-btn">
                      <Link to="blog-details.html">Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Blog Item */}
            <div className="col-lg-12">
              <div className="ltn__blog-item ltn__blog-item-3">
                <div className="ltn__blog-img">
                  <Link to="blog-details.html">
                    <img src="img/blog/5.jpg" alt="#" />
                  </Link>
                </div>
                <div className="ltn__blog-brief">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author">
                        <Link to="#">
                          <i className="far fa-user" />
                          by: Admin
                        </Link>
                      </li>
                      <li className="ltn__blog-tags">
                        <Link to="#">
                          <i className="fas fa-tags" />
                          Trends
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <h3 className="ltn__blog-title">
                    <Link to="blog-details.html">
                      7 home trends that will shape your house in 2021
                    </Link>
                  </h3>
                  <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-date">
                          <i className="far fa-calendar-alt" />
                          June 24, 2021
                        </li>
                      </ul>
                    </div>
                    <div className="ltn__blog-btn">
                      <Link to="blog-details.html">Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
          </div>
        </div>
      </div>
      {/* BLOG AREA END */}
    </>
  );
}
